import { FilePath, TabNavigation } from "@sandbox/code-editor";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { closeFile, openFile } from "store/features";

export const Tabs = () => {
  const openFiles = useAppSelector((state) => state.activeSandbox.editor.openFiles);
  const dispatch = useAppDispatch();

  const onItemChanged = (filePath: FilePath) => {
    dispatch(openFile({ filePath: filePath }));
  }

  const onItemClosed = (filePath: FilePath) => {
    dispatch(closeFile(filePath));
  }

  return (
    <TabNavigation
      items={openFiles}
      onItemChanged={onItemChanged}
      onItemClosed={onItemClosed}
    />
  )
}